// Initially hide certain links from google bots, for SEO optimization
export default function convertToLinks() {
  document.querySelectorAll('span.js-menu-span-link').forEach(span => {
    let anchor = document.createElement('a');
    Array.from(span.attributes).forEach(attr => {
        anchor.setAttribute(attr.name, attr.value);
        anchor.setAttribute('rel', 'nofollow')
    });
    anchor.href = span.getAttribute('data-href');
    while(span.firstChild) {
        anchor.appendChild(span.firstChild);
    };
    span.parentNode.replaceChild(anchor, span);
  });
}
